import { render, staticRenderFns } from "./CommentExam.vue?vue&type=template&id=fcb4031a&scoped=true&"
import script from "./CommentExam.vue?vue&type=script&lang=js&"
export * from "./CommentExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb4031a",
  null
  
)

export default component.exports